module.exports = __webpack_public_path__ + "static/media/errorLogo.35414161.svg";